import { SearchNotOrdered } from "./types";

const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
const isSameDay = (a: Date, b: Date) => startOfDay(a).getTime() === startOfDay(b).getTime();

const today = new Date();
const todayStart = startOfDay(today);
const plus3DaysStart = new Date(todayStart);
plus3DaysStart.setDate(plus3DaysStart.getDate() + 3);

export const processSearchStatuses = (rows: SearchNotOrdered[]) => {
  for (const entity of rows) {
    if (entity.status && entity.status !== "Ordered") {
      entity.frontendStatus = entity.status;
      continue;
    }

    entity.frontendStatus = "Ordered";

    const etaDate = entity.eta ? startOfDay(new Date(entity.eta)) : null;

    const has = (value: string) => entity.notes?.some((n) => n.text.includes(value)) ?? false;
    const hasToday = (value: string) =>
      entity.notes?.some((n) => n.text.includes(value) && isSameDay(new Date(n.dateCreated), today)) ?? false;
    const hasBeforeToday = (value: string) =>
      entity.notes?.some((n) => n.text.includes(value) && startOfDay(new Date(n.dateCreated)) < todayStart) ?? false;

    // Due (ETA in the past)
    if (etaDate && etaDate < todayStart) {
      entity.frontendStatus = "Overdue";
      continue;
    }

    // Due (ETA today)
    if (etaDate && isSameDay(etaDate, todayStart)) {
      entity.frontendStatus = "Due";
      continue;
    }

    // No ETA
    if (!etaDate) {
      if (hasToday("Requested ETA") || hasToday("ETA Requested")) {
        entity.frontendStatus = "ETA Requested";
      } else {
        entity.frontendStatus = "Awaiting ETA";
        entity.actionKey = "Requested";
      }
      continue;
    }

    // ETA exists (future or today)
    if (has("ETA Confirmed")) {
      entity.frontendStatus = "ETA Confirmed";
      continue;
    }

    if (hasToday("ETA Accuracy Requested")) {
      entity.frontendStatus = "ETA Accuracy Requested";
      entity.actionKey = "Confirmed";
      continue;
    }

    if (hasBeforeToday("ETA Accuracy Requested") || etaDate < plus3DaysStart) {
      entity.frontendStatus = "ETA Upcoming";
      entity.actionKey = "Requested";
      continue;
    }
  }

  return rows;
};
